import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home, Leaf, GraduationCap, CheckCircle, Factory } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
const activities = [{
  title: 'Seed Distribution',
  description: 'Providing high-quality, certified cotton seeds to farmers across the country.',
  icon: Leaf
}, {
  title: 'Farmer Training',
  description: 'Educating farmers on best agronomic practices for optimal cotton yields.',
  icon: GraduationCap
}, {
  title: 'Quality Control',
  description: 'Ensuring Ugandan cotton meets international quality standards.',
  icon: CheckCircle
}, {
  title: 'Ginning Regulation',
  description: 'Regulating and monitoring cotton ginning operations to maintain fiber quality.',
  icon: Factory
}];
export function CdougaPage() {
  return <>
      <Header data-id="element-601" />
      <main className="flex-grow pt-[160px] md:pt-[148px] bg-gray-50 pb-20" data-id="element-602">
        <div className="relative text-white py-32 md:py-48 overflow-hidden" data-id="element-603">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1600&h=600&fit=crop")'
        }} data-id="element-604"></div>
          <div className="absolute inset-0 bg-uganda-green/80" data-id="element-605"></div>
          <div className="relative max-w-7xl mx-auto px-4 md:px-8" data-id="element-606">
            <div className="flex items-center text-sm text-green-100 mb-6" data-id="element-607">
              <Link to="/" className="hover:text-white flex items-center" data-id="element-608">
                <Home className="w-4 h-4 mr-1" data-id="element-609" /> Home
              </Link>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-610" />
              <span data-id="element-611">Programs & Projects</span>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-612" />
              <span className="text-white font-medium" data-id="element-613">CDOUGA</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-614">CDOUGA</h1>
            <p className="text-lg text-green-50 max-w-3xl leading-relaxed" data-id="element-615">
              Cotton Development Organisation Uganda.
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-8 py-12" data-id="element-616">
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 mb-12" data-id="element-617">
            <h2 className="text-2xl font-bold text-uganda-black mb-4" data-id="element-618">
              Our Mandate
            </h2>
            <p className="text-gray-600 leading-relaxed text-lg" data-id="element-619">
              To promote, regulate, and facilitate the production, processing,
              and marketing of cotton in Uganda to enhance its contribution to
              the national economy.
            </p>
          </div>

          <h2 className="text-2xl font-bold text-uganda-black mb-8" data-id="element-620">
            Key Activities
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-621">
            {activities.map((activity, index) => {
            const Icon = activity.icon;
            return <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-622">
                  <div className="w-12 h-12 bg-green-100 text-uganda-green rounded-lg flex items-center justify-center mb-4" data-id="element-623">
                    <Icon className="w-6 h-6" data-id="element-624" />
                  </div>
                  <h3 className="text-lg font-bold text-uganda-black mb-2" data-id="element-625">
                    {activity.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-626">
                    {activity.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </main>
      <Footer data-id="element-627" />
    </>;
}